import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '~/routes/use-on-load';
import { P2GBox } from '@parcel2go/core-ui';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

// Standalone consumer-view route for PrePay & Balance. Mounts the existing component
// directly (no billing tab bar); the SmartSend /billing page is untouched.
const PrePay = lazy(() => import('~/apps/prepay/prepay'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.PREPAY);

  useOnLoad(() => {
    const title = t('PREPAY_PAGE_TITLE', { defaultValue: 'PrePay & Balance' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.PREPAY });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.PrePay }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.PrePay
      }
    });
  });

  return (
    <Tagged tag="screen-prepay">
      <Suspense>
        <P2GBox>
          <PrePay />
        </P2GBox>
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'PrePay & Balance';
